import { GAME_CONFIG } from '../config/gameConfig';

/**
 * ComboSystem: Tracks rapid consecutive kills and applies
 * score multipliers for streaks.
 */
export class ComboSystem {
  private comboCount = 0;
  private multiplier = 1;
  private lastKillTime = 0;
  private timeout: number;
  private maxMultiplier: number;

  constructor() {
    this.timeout = GAME_CONFIG.scoring.comboTimeout;
    this.maxMultiplier = GAME_CONFIG.scoring.comboMultiplierMax;
  }

  registerKill(time: number): number {
    const elapsed = time - this.lastKillTime;

    if (elapsed < this.timeout) {
      this.comboCount++;
      this.multiplier = Math.min(
        1 + Math.floor(this.comboCount / 3),
        this.maxMultiplier
      );
    } else {
      this.comboCount = 1;
      this.multiplier = 1;
    }

    this.lastKillTime = time;
    return this.multiplier;
  }

  getMultiplier(): number {
    return this.multiplier;
  }

  getComboCount(): number {
    return this.comboCount;
  }

  checkExpiry(time: number): boolean {
    if (time - this.lastKillTime > this.timeout && this.comboCount > 0) {
      this.comboCount = 0;
      this.multiplier = 1;
      return true; // Combo expired
    }
    return false;
  }

  reset(): void {
    this.comboCount = 0;
    this.multiplier = 1;
    this.lastKillTime = 0;
  }
}
